import { render, staticRenderFns } from "./DxDetailTabProducts.vue?vue&type=template&id=7b9bc90f&"
import script from "./DxDetailTabProducts.vue?vue&type=script&lang=js&"
export * from "./DxDetailTabProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports